import { Component, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    selector: 'xui-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    imports: [MatProgressBarModule]
})
export class LoadingBarComponent implements OnInit {

  ngOnInit(): void {
  }

}
